export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show_: {
      get() {
        return this.show;
      },
      set(show) {
        this.$emit('update:show', show);
      },
    },
  },
}
